import { createRouter, createWebHistory } from 'vue-router';
import Cadastro from '../views/Cadastro.vue'; // OK
import LogarView from '../views/LogarView.vue'; // OK
import PaginaInicial from '../views/PaginaInicial.vue'; // OK
import PaginaAdmin from '../views/PaginaAdmin.vue'; // OK
import Jogos from '../views/Jogos.vue';
import Resultados from '../views/Resultados.vue';
import GerenciarUsuarios from '../views/GerenciarUsuarios.vue'; // OK
import GerenciarJogadores from '../views/GerenciarJogadores.vue'; // OK
import GerenciarGrupos from '../views/GerenciarGrupos.vue'; // OK
import GerenciarEtapas from '../views/GerenciarEtapas.vue'; // OK
import Configuracoes from '../views/Configuracoes.vue';
import Grupos from '@/views/Grupos.vue';
import GerenciarPenalidades from "@/views/GerenciarPenalidades.vue";


const routes = [
  {
    path: '/cadastro',
    name: 'cadastro',
    component: Cadastro
  },
  {
    path: '/',
    name: 'login',
    component: LogarView
  },
  {
    path: '/homepage',
    name: 'paginaInicial',
    component: PaginaInicial,
  },
  {
    path: '/jogos',
    name: 'jogos',
    component: Jogos
  },
  {
    path: '/resultados',
    name: 'resultados',
    component: Resultados,
    meta: { requireAuth: true}
  },
  {
    path: '/admin',
    name: 'paginaAdmin',
    component: PaginaAdmin,
    meta: { requireAuth: true}
  },
  {
    path: '/admin/users',
    name: 'gerenciarUsuarios',
    component: GerenciarUsuarios,
    meta: { requireAuth: true}
  },
  {
    path: '/admin/players',
    name: 'gerenciarJogadores',
    component: GerenciarJogadores,
    meta: { requireAuth: true}
  },
  {
    path: '/admin/groups',
    name: 'gerenciarGrupos',
    component: GerenciarGrupos,
    meta: { requireAuth: true }
  },
  {
    path: '/admin/stages',
    name: 'gerenciarEtapas',
    component: GerenciarEtapas,
    meta: { requireAuth: true}
  },
  {
    path: '/settings',
    name: 'configuracoes',
    component: Configuracoes,
    meta: { requireAuth: true}
  },
  {
    path: '/grupos',
    name: 'grupos',
    component: Grupos
  },
  {
    path: '/admin/penalidades',
    name: 'penalidades',
    component: GerenciarPenalidades
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const loggedIn = !!localStorage.getItem('user');

  if(to.matched.some(record => record.meta.requireAuth) && !loggedIn){
    next('/login');
  }else{
    next();
  }
});

export default router;
